import * as React from "react";
import * as moment from "moment";
import Model from "hooks/Model";
import { databaseService, messagingService } from "utils/firebase";
import { Store } from "hooks/main_store";
import LocalStorage from "utils/localStorage";
import { isIOS, isNotificationSupported } from "utils/validations";
import { detectIncognito } from "utils/detectIncognito";

const PushNotifications = () => {
  const { state } = React.useContext(Store);

  const initOnMessage = () => {
    messagingService.onMessage((payload) => {
      Model.setData("dialog", {
        open: true,
        title: payload.notification.title,
        text: payload.notification.body,
        txtRight: "OK",
        fnRight: () => {
          Model.setData("dialog", {
            open: false,
          });
        },
      });
    });
  };

  const runGetToken = async () => {
    try {
      const currentToken = await messagingService.getToken();

      if (currentToken) {
        initOnMessage();
        const lastToken = (
          await databaseService.getDatabase(
            `usersNotificationToken/${state.infoUser.uid}`,
          )
        ).val()?.token;

        if (lastToken !== currentToken) {
          await databaseService.saveDatabase(
            `usersNotificationToken/${state.infoUser.uid}`,
            { token: currentToken, created: moment().format("x") },
          );
        }
      }
    } catch (error) {
      console.log("PN error: ", error);
    }
  };

  const rejectNotifications = async () => {
    try {
      const result = await detectIncognito();
      LocalStorage(result.isPrivate).setItem("hidePushNotifications", "true");
    } catch (error) {
      console.log("Error canInstalPwa: ", error);
    }
  };

  const firstLoad = () => {
    if (isIOS() || !isNotificationSupported()) return;

    if (
      (Notification.permission === "default" || !Notification.permission) &&
      !state.dialog.open
    ) {
      Model.setData("dialog", {
        open: true,
        title: "📢 Activa las notificaciones",
        text: "No te pierdas ninguna novedad de nuestras dinámicas y recibe información relevante 🤑",
        txtLeft: "Rechazar",
        fnLeft: () => {
          Model.setData("dialog", {
            open: false,
          });
          rejectNotifications();
        },
        txtRight: "Acepto",
        fnRight: () => {
          Model.setData("dialog", {
            open: false,
          });
          runGetToken();
        },
      });
    }
  };

  React.useEffect(() => {
    let callback;
    const hidePushNotifications = LocalStorage(false).getItem(
      "hidePushNotifications",
    );

    if (isIOS() || !isNotificationSupported()) return;

    if (state.infoUser?.uid && hidePushNotifications !== "true") {
      if (Notification.permission === "granted") {
        runGetToken();
      } else {
        // callback = setTimeout(firstLoad, 10000);
        callback = setTimeout(() => {}, 10000);
      }
    }

    return () => clearTimeout(callback);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.infoUser]);

  return <></>;
};

export default PushNotifications;
